import { useTranslations } from "@/lib/static-intl";

const AddPlaceButton = ({ openPlaceAddModal }) => {
  const t = useTranslations("places");
  return (
    <button
      type="button"
      onClick={openPlaceAddModal}
      className="px-4 py-2 text-inherit text-xs text-center italic"
    >
      {t("cant_find_a_place")}
      <br />{" "}
      <span className="hover:font-semibold transition text-center">
        {t("add_it_here")}
      </span>
    </button>
  );
};

export default AddPlaceButton;
